import { render } from "./bidangHortikultura.vue?vue&type=template&id=531625ec"
import script from "./bidangHortikultura.vue?vue&type=script&lang=js"
export * from "./bidangHortikultura.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__